import { useEffect, useState } from 'react';
import { marketplaceaccountApi, type ChannelConfiguration, type MarketplaceAccount } from '../../api/marketplaceaccount';

export function ChannelSettingsPage() {
  const [accounts, setAccounts] = useState<MarketplaceAccount[]>([]);
  const [selected, setSelected] = useState('');
  const [config, setConfig] = useState<ChannelConfiguration | null>(null);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    void marketplaceaccountApi.list().then(setAccounts).catch((e) => setError(String(e)));
  }, []);

  useEffect(() => {
    if (!selected) return;
    void marketplaceaccountApi.getConfig(selected).then(setConfig).catch((e) => setError(String(e)));
  }, [selected]);

  async function save() {
    if (!selected || !config) return;
    setError('');
    try {
      const updated = await marketplaceaccountApi.updateConfig(selected, config);
      setConfig(updated);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-6">
      <h1 className="text-2xl font-semibold">Channel Settings</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {saved && <p className="mt-4 text-sm text-green-600">Saved.</p>}
      <select className="mt-4 w-full rounded border p-2" value={selected} onChange={(e) => setSelected(e.target.value)}>
        <option value="">Select account</option>
        {accounts.map((a) => <option key={a.id} value={a.id}>{a.display_name}</option>)}
      </select>
      {config && (
        <div className="mt-6 space-y-4">
          <input className="w-full rounded border p-2" placeholder="Default warehouse ID" value={config.default_warehouse_id ?? ''} onChange={(e) => setConfig({ ...config, default_warehouse_id: e.target.value })} />
          <input className="w-full rounded border p-2" placeholder="Default currency" value={config.default_currency ?? ''} onChange={(e) => setConfig({ ...config, default_currency: e.target.value })} />
          <input className="w-full rounded border p-2" placeholder="Default price book ID" value={config.default_price_book_id ?? ''} onChange={(e) => setConfig({ ...config, default_price_book_id: e.target.value })} />
          <input className="w-full rounded border p-2" placeholder="Default inventory rule" value={config.default_inventory_rule ?? ''} onChange={(e) => setConfig({ ...config, default_inventory_rule: e.target.value })} />
          <input className="w-full rounded border p-2" placeholder="Default sync rule" value={config.default_sync_rule ?? ''} onChange={(e) => setConfig({ ...config, default_sync_rule: e.target.value })} />
          <button type="button" className="rounded bg-slate-900 px-4 py-2 text-white" onClick={() => void save()}>Save</button>
        </div>
      )}
    </div>
  );
}
